import { ensureState } from 'redux-optimistic-ui';
import { createSelector } from 'reselect';
import { SOFTWARE_PROJECT } from '@atlassian/jira-common-constants/src/project-types.tsx';
import { BASE_HIERARCHY_TYPE } from '@atlassian/jira-issue-type-hierarchies/src/index.tsx';
import { getNextgenSettingsIssueTypesUrl } from '@atlassian/jira-project-settings-apps-common/src/urls.tsx';
import type { CardType } from '../../../model/types.tsx';
import type { State } from '../../types.tsx';
import { getBaseUrl, getProjectKey } from '../app/index.tsx';

export const getCardTypes = (state: State): CardType[] => ensureState(state.entities).cardTypes;

export const getBaseLevelCardTypes = createSelector(getCardTypes, (cardTypes) =>
	cardTypes.length > 0
		? cardTypes?.filter((issueType) => issueType.typeHierarchyLevel === BASE_HIERARCHY_TYPE)
		: [],
);

export const getCardTypesForFilter = createSelector(getBaseLevelCardTypes, (cardTypes) =>
	cardTypes.map((cardType) => ({
		id: String(cardType.id),
		name: cardType.name,
		iconUrl: cardType.iconUrl,
	})),
);

export const cardTypeIdsSelector = createSelector(getBaseLevelCardTypes, (cardTypes) =>
	cardTypes.map((cardType) => String(cardType.id)),
);

export const manageIssueTypesSelector = createSelector(
	[getBaseUrl, getProjectKey],
	(_, projectKey) => getNextgenSettingsIssueTypesUrl(SOFTWARE_PROJECT, projectKey),
);

export const getHasAnyIssueTypeWithRequireFields = createSelector(
	[getBaseLevelCardTypes],
	(cardTypes) => cardTypes.some((cardType) => cardType.hasRequiredFields),
);
